<div class="tw-w-full tw-h-[240px] tw-flex tw-flex-col tw-gap-3 tw-justify-center tw-items-center">

  <div class="logo-fill">
    <div class="logo-fill__layer">
      <img class="logo-fill__img logo-fill__img--fill" [src]="image1" alt="logo" height="96" width="96">
    </div>

    <div class="logo-fill__layer">
      <img class="logo-fill__img" [src]="image2" alt="logo" height="96" width="96">
    </div>
  </div>

  <div class="box-loading-text tw-mt-4 tw-text-center">
    <h1 class="smsir-h5-lg tw-m-0"><strong>از صبر و شکیبایی شما سپاسگزاریم</strong></h1>
  </div>

</div>
